import * as React from 'react'
import { ReactElement } from 'react'
import { Button } from '@fluentui/react-components'
import { ArrowRepeatAllFilled, ArrowRepeatAllRegular, bundleIcon, DocumentDismissFilled, DocumentDismissRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { useQueue } from '../../hooks/useQueue'
import useQueueDispatch from '../../hooks/queue/useQueueDispatch'
import { AnyQueueData, QueueStatus, settledQueueStatuses } from '../../hooks/queue/queueTypes'

const RepeatIcon = bundleIcon(ArrowRepeatAllFilled, ArrowRepeatAllRegular)
const DismissIcon = bundleIcon(DocumentDismissFilled, DocumentDismissRegular)

type QueueToastActionsProps = {
    id: string
    job: AnyQueueData
}

/**
 * The restart and cancel buttons that every cancellable queue toast shows: restart is offered when the job was
 * rejected as a duplicate, cancel for as long as the job can still change.
 */
export default function QueueToastActions({ id, job }: QueueToastActionsProps): ReactElement {
    const { t: translate } = useTranslation()
    const queue = useQueue()
    const dispatch = useQueueDispatch(job.kind)
    const status = job.status.current

    return (
        <>
            {status === QueueStatus.Duplicate && (
                <Button icon={<RepeatIcon />} appearance="subtle" onClick={() => dispatch(id, job.context, job.status, true)}>
                    {translate('toast.restart')}
                </Button>
            )}
            {!settledQueueStatuses.includes(status) && (
                <Button icon={<DismissIcon />} appearance="subtle" onClick={() => queue.transition(id, QueueStatus.Cancelled)}>
                    {translate('toast.cancel')}
                </Button>
            )}
        </>
    )
}
